import { ModelFactory } from "../../../ModelFactory";

export class WebserverConfig {
  constructor(
    public readonly config: { [name: string]: string },
  ) {
  }
}

class WebserverConfigFactory extends ModelFactory<WebserverConfig> {
  protected fromJson(json: any): WebserverConfig {
    return new WebserverConfig(
      json['config'],
    );
  }
}
export const webserverConfigFactory = new WebserverConfigFactory();
